import React from 'react';
import { connect } from 'redux-bundler-react';
import classnames from 'classnames';

class BasicToolbarButton extends React.Component {
  constructor(props){
    super(props);
    this.state = { 
      open: false
    }
    this.renderIcon = this.renderIcon.bind(this);
    this.toggleTool = this.toggleTool.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps){
    const { activeBasicTool, title, onDeactivate } = newProps;
    if(activeBasicTool !== title && this.state.open) this.setState({ 
      open: false
    }, () => {
      if(!this.state.open && onDeactivate) onDeactivate();
    });
  }

  handleClick(){
    const { enabled, doActivateBasicTool, doDeactivateBasicTool, activeBasicTool, title, onActivate, onDeactivate, disabled  } = this.props;
    if(disabled) return;
    if(!enabled) return;
    const active = activeBasicTool === title;
    if(active){
      doDeactivateBasicTool();
      if(onDeactivate) onDeactivate();
    }else{
      doActivateBasicTool({
        activeTool: title
      });
      if(onActivate) onActivate();
    }
  }

  toggleTool(){
    const { enabled, doActivateBasicTool, title, doDeactivateBasicTool, onActivate, onDeactivate, disabled } = this.props;
    if(disabled) return;
    if(!enabled) return;
    this.setState({open:!this.state.open}, () => {
      if(this.state.open){
        doActivateBasicTool({
          activeTool: title
        })
        if(onActivate) onActivate();
      }else{
        doDeactivateBasicTool()
        if(onDeactivate) onDeactivate();
      }
    })
  }

  renderIcon(){
    const { children, theme, text, title, iconClass, iconStyle, activeBasicTool, dropup, disabled } = this.props;

    const btnClass = classnames({
      'btn': true,
      'btn-default': true,
      'btn-lg': true,
      'basic-toolbar-btn': true,
      'dropdown-toggle': true,
      'active': (activeBasicTool === title),
      'disabled':disabled
    })

    const arrowIcon = classnames({
      'mdi': true,
      'mdi-menu-down': !dropup,
      'mdi-menu-up': dropup
    })

    if(children){
      return (
        <div onClick={ this.toggleTool } className={ btnClass + " " + theme } disabled={disabled}>
          <i className={ iconClass } style={ iconStyle }/>{ text }
          <i className={ arrowIcon } />
        </div>
      )
    }else{
      return (
        <div  onClick={ this.toggleTool } className={ btnClass + " " + theme } disabled={disabled} style={{textAlign: 'center'}}>
          <i className={ iconClass } style={ iconStyle }/>{ text }
        </div>
      )
    }
  }

  render(){
    const { theme, activeBasicTool, title, children, dropup, passProps } = this.props;
    const { open } = this.state;

    const btnContainerClass = classnames({
      [theme]: true,
      'btn-group': true,
      'open': open
    })

    const activeClass = classnames({
      'basic-toolbar-btn-active': !dropup,
      'basic-toolbar-btn-active-top': dropup,
      'hidden': !(activeBasicTool === title)
    })

    return (
      <div className={btnContainerClass} {...passProps} title={title}>
        <div className={activeClass} />
        { this.renderIcon() }
        { children }
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'selectActiveBasicTool',
  'doActivateBasicTool',
  'doDeactivateBasicTool',
  BasicToolbarButton
);